/**
 * The page is imported from **its own module**, not from the `@pages` barrel — the barrel would pull
 * every page into one preloaded chunk and defeat code-splitting by route.
 */
import { createFileRoute } from '@tanstack/react-router';

import { AcknowledgementsPage } from '@pages/acknowledgements/page.js';
import { IamService } from '@units/iam';

/**
 * `/acknowledgements` — что направлено на ознакомление **этому** человеку.
 *
 * Гард — `acknowledgement:read`, и отказ здесь **403, а не 404**, в отличие от карточки акта:
 * существование раздела внутри организации не тайна — он стоит в меню у всех, кто держит право, — а
 * тайной является содержимое конкретного акта. Строки чужих людей этот адрес не выражает вовсе:
 * скоуп — сам вызывающий, и сужает выборку сервер в SQL (`rules/permissions.mdc`, инвариант 2).
 *
 * Ни `loader`, ни `validateSearch`: перечень не постраничный и не фильтруемый — операция
 * `GET /me/acknowledgements` не принимает ни одного параметра, — поэтому в адресе нечему жить.
 */
export const Route = createFileRoute('/_authenticated/acknowledgements')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'acknowledgement:read',
    whenDenied: 'forbidden',
  }),
  component: AcknowledgementsPage,
  staticData: { crumbKey: 'nav.acknowledgements' },
});
